import { Component, OnInit,Inject,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { DialogRechazarSolicitudAfiliacionComponent } from 'src/app/components/solicitud-afiliacion/dialog-rechazar-solicitud-afiliacion.component';
import { DialogDesafiliarAfiliacionComponent } from 'src/app/components/solicitud-afiliacion/dialog-desafiliar-afiliacion.component';
import { DialogSolicitarDesafiliarAfiliacionComponent } from 'src/app/components/solicitud-afiliacion/dialog-solicitar-desafiliar-afiliacion.component';
import { AfiliacionComponent } from 'src/app/components/afiliacion/afiliacion.component';
import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialogEspecial } from '../confirmation-dialog/confirmation-dialog-especial.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab7',
  templateUrl: '../../pages/afiliacion/afiliacion.tab7.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.component.css']
})
export class AfiliacionTab7Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    idEjecutivo = localStorage.getItem("idUsuario")
    @Input() afiliado: Afiliado;
    diasDiferencia: any;
    bancos: any;
    postulantes: any[];
    termino:any;
    constructor(private router:Router, private escolaridadService:EscolaridadService,
                private afiliacionService:AfiliacionService, private dialog: MatDialog,
                private afiliacionComponent:AfiliacionComponent,
                private mantenedorService: MantenedorUsuariosService) { }

    ngOnInit(): void
    {   
        let vm = this

    }
   

    rechazarSolicitud(rut: any)
    {        
      var vm = this
      let dataRechazo: any =
      {       
          rut: rut,
          nombreCompleto: '',
      }
      let data: any = {}
        const dialogRef = this.dialog.open(DialogRechazarSolicitudAfiliacionComponent, { data: dataRechazo,  disableClose: true, width: '45%' })
        dialogRef.afterClosed().subscribe(() => {
            vm.afiliacionComponent.buscar(true, false,'Se ha rechazado la solicitud.')
            Swal.close();       
           
        })
    }

    desafiliarAfiliado(rut: any)
    {        
      var vm = this
      let data: any =
      {       
          rut: rut,
          termino: false
      }
        const dialogRef = this.dialog.open(DialogDesafiliarAfiliacionComponent, { data: data,  disableClose: true, width: '35%' })
        dialogRef.afterClosed().subscribe(result => {          
            Swal.close();
         
            if(data.termino){
                vm.afiliacionComponent.buscar(true, false,'Se ha desafiliado el Afiliado.')
            }   
        })
    }
    
    solicitarDesafiliarAfiliado(rut: any)
    {        
      var vm = this
      let data: any =
      {       
          rut: rut,  
          termino: false     
      }
        const dialogRef = this.dialog.open(DialogSolicitarDesafiliarAfiliacionComponent, { data: data,  disableClose: true, width: '40%' })
        dialogRef.afterClosed().subscribe(result => {          
            Swal.close();
        
            if(data.termino){
                vm.afiliacionComponent.buscar(true, false,'Se ha ingresado su solicitud de desafiliación.')
            }  
        })
    }

    
   
    aprobarSolicitud(rut: any, fechaAfiliacion:any)
    {
      var vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
    
        let fechaAfiliacionTemp = ''
        if (fechaAfiliacion) {
            fechaAfiliacionTemp = fechaAfiliacion.split('-')[2] + '-' + fechaAfiliacion.split('-')[1] + '-' +
            fechaAfiliacion.split('-')[0]
        } else {
            vm.openAlertDialog('El campo fecha de afiliación no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        this.afiliacionService.aprobarSolicitud(rut,fechaAfiliacionTemp,vm.idEjecutivo).then
        (
            response =>
            {
                vm.afiliacionComponent.buscar(true, false,'Se ha aprobado la solicitud de afiliación.')
                Swal.close();              
            }
        )
        .catch
        (
            () =>
            {
           
            }
        )
    }

    
    afiliarFuncionario(rut: any, fechaAfiliacion:any)
    {
      var vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
    
        let fechaAfiliacionTemp = ''
        if (fechaAfiliacion) {       
            fechaAfiliacionTemp = fechaAfiliacion.split('-')[2] + '-' + fechaAfiliacion.split('-')[1] + '-' +
            fechaAfiliacion.split('-')[0]
        } else {
           const fechaObj = new Date();
           const dia = fechaObj.getDate().toString().padStart(2, '0');
           const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
           const anio = fechaObj.getFullYear();
           fechaAfiliacionTemp=`${dia}-${mes}-${anio}`
        }
       
        this.afiliacionService.afiliarFuncionario(rut,fechaAfiliacionTemp,vm.idEjecutivo).then
        (
            response =>
            {
                vm.afiliacionComponent.buscar(true, false,'Se ha afiliado el funcionario.')
                Swal.close();              
            }
        )
        .catch
        (
            () =>
            {
           
            }
        )
    }

  
    afiliadoPensionado(rut: any, fechaAfiliacion:any,id:any){
        var vm = this
        const dialogRef = this.dialog.open(ConfirmationDialogEspecial,
            {
              data: { message: '¿Se encuentra seguro de pasar el Afiliado a PENSIONADO?',
              botonStyleCancel:"margin-left:20%;",
              botonStyleAceptar:"margin-left:20%;",
              buttonText: { ok: 'Si', cancel: 'No' } }
            })
          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              let fechaAfiliacionTemp = ''
              if (fechaAfiliacion) {
                  fechaAfiliacionTemp = fechaAfiliacion.split('-')[2] + '-' + fechaAfiliacion.split('-')[1] + '-' +
                  fechaAfiliacion.split('-')[0]
              }
              Swal.fire({
                allowOutsideClick: false,
                icon: 'info',
                text: 'Cargando...'
              });
              Swal.showLoading();
              this.afiliacionService.cambiarAfiliadoPensionado(rut,vm.idEjecutivo,fechaAfiliacionTemp,id).then
                (
                  response => {
                    vm.afiliacionComponent.buscar(true, false,'El Afiliado ha pasado a Pensionado.')
                    //vm.openAlertDialog('El Afiliado a pasado a Pensionado', 'btn-success')
                    Swal.close();
                    return false;
                  }
                )
                .catch
                (
                  () => {
                    Swal.close();
                  }
                )
               
            }
          })

    }

    

    rechazarDesafiliacion(rut: any,fechaAfiliacion: any)
    {
      var vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
       
        let fechaAfiliacionTemp = ''
        if (fechaAfiliacion) {       
            fechaAfiliacionTemp = fechaAfiliacion.split('-')[2] + '-' + fechaAfiliacion.split('-')[1] + '-' +
            fechaAfiliacion.split('-')[0]
        } else {
           const fechaObj = new Date();
           const dia = fechaObj.getDate().toString().padStart(2, '0');
           const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
           const anio = fechaObj.getFullYear();
           fechaAfiliacionTemp=`${dia}-${mes}-${anio}`
        }
        
        this.afiliacionService.rechazarDesafiliacion(rut,fechaAfiliacionTemp,vm.idEjecutivo).then
        (
            response =>
            {
                vm.afiliacionComponent.buscar(true, false,'Se ha rechazado la solicitud de desafiliación.')
                Swal.close();              
            }
        )
        .catch
        (
            () =>
            {
           
            }
        )
    }
    
    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
